import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

export default function ProductCard({ product, onAddToCart }) {
  const [added, setAdded] = useState(false);

  const handleAdd = () => {
    onAddToCart(product);
    setAdded(true);
  };

  return (
    <div className="product-card">
      <Link to={`/product/${product.id}`} className="product-card__link">
        <img
          src={product.image}
          alt={product.name}
          className="product-card__img"
        />
        <h2 className="product-card__name">{product.name}</h2>
        <p className="product-card__price">${product.price.toFixed(2)}</p>
      </Link>

      <button
        className="product-card__btn"
        onClick={handleAdd}
        disabled={added}
      >
        {added ? 'Added to Cart' : 'Add to Cart'}
      </button>
    </div>
  );
}
